module.exports = __webpack_public_path__ + "img/be-where-your-customers-are.7a432ba1.png";